import { render, staticRenderFns } from "./CVV.vue?vue&type=template&id=2b82016b&scoped=true"
import script from "./CVV.vue?vue&type=script&lang=js"
export * from "./CVV.vue?vue&type=script&lang=js"
import style0 from "./CVV.vue?vue&type=style&index=0&id=2b82016b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82016b",
  null
  
)

export default component.exports